<template>
  <v-select
    v-if="!is_autocomplete"
    :class="classes"
    outlined
    v-bind="$attrs"
    v-on="$listeners"
    :items="items"
    flat
    :item-value="item_value"
    :return-object="return_object"
    :hide-details="!has_error"
    :menu-props="menu_props"
  >

    <template
      v-if="has_all_selected"
      v-slot:prepend-item
    >
      <v-list-item
        ripple
        @mousedown.prevent
        @click="toggle"
      >
        <v-list-item-action>
          <v-icon :color="icon_color">
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Выбрать всё
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <slot
      v-for="(_, name) in $slots"
      :slot="name"
      :name="name"
    />

    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </v-select>
  <v-autocomplete
    v-else
    :class="classes"
    outlined
    v-bind="$attrs"
    v-on="$listeners"
    :items="items"
    flat
    :item-value="item_value"
    :return-object="return_object"
    :hide-details="!has_error"
    :search-input.sync="search_value"
    :menu-props="{
      rounded: 'sm',
      offsetY: true,
    }"
  >

    <template
      v-if="has_all_selected"
      v-slot:prepend-item
    >
      <v-list-item
        ripple
        @mousedown.prevent
        @click="toggle"
      >
        <v-list-item-action>
          <v-icon :color="icon_color">
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Выбрать всё
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <slot
      v-for="(_, name) in $slots"
      :slot="name"
      :name="name"
    />

    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </v-autocomplete>
</template>

<script lang="ts">
import { SelectItem } from '@/types';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { del_mask } from '@/utils';

@Component
export default class Select extends Vue {
  @Prop({ type: Boolean, default: false })
  blue_icon!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly!: boolean;

  @Prop({ type: Boolean, default: false })
  error!: boolean;

  @Prop({ type: Boolean, default: false })
  has_all_selected!: boolean;

  @Prop({ type: Array, default: () => ([]) })
  items!: SelectItem[];

  @Prop({ type: Boolean, default: false })
  require!: boolean;

  @Prop({ type: String, default: 'value' })
  item_value!: string;

  @Prop({ type: Boolean, default: false })
  return_object!: boolean;

  @Prop({ type: Boolean, default: false })
  is_autocomplete!: boolean;

  @Prop({ type: Object, default: () => ({ offsetY: true }) })
  menu_props!: Record<string, unknown>;

  model_val: SelectItem[] = [];

  // autocomplete
  search_value = null;
  @Watch('search_value')
  on_search(val: string) {
    this.$emit('search_input', val);
  }

  get icon_color() {
    return this.$attrs.value && this.$attrs.value.length > 0 ? 'indigo darken-4' : '';
  }

  get has_error() {
    if ('hide-details' in this.$attrs) {
      return !!this.$attrs['hide-details'];
    }

    if (this.error) {
      return false;
    }

    return true;
  }

  get classes() {
    return [
      'text-field',
      { readonly: this.readonly },
      { blue_icon: this.blue_icon },
      { has_error: this.has_error },
      { require: this.require },
    ];
  }

  get all_selected() {
    return this.$attrs.value?.length === this.items?.length;
  }

  get some_selected() {
    return this.$attrs.value?.length > 0 && !this.all_selected;
  }

  get icon() {
    if (this.all_selected) {
      return 'mdi-close-box';
    }
    if (this.some_selected) {
      return 'mdi-minus-box';
    }
    return 'mdi-checkbox-blank-outline';
  }

  toggle() {
    this.$nextTick(() => {
      if (this.all_selected) {
        this.$emit('input', []);
      } else {
        let items = this.items.slice();

        if (!this.return_object) {
          if (this.item_value !== 'value') {
            items = this.items.map((e) => e[this.item_value]) as SelectItem[];
          } else {
            items = this.items.map((e) => e.value) as SelectItem[];
          }
        }
        this.$emit('input', items);
      }
    });
  }
}
</script>

<style lang="scss" src="../inputs.scss" />
